'use strict';

exports.__esModule = true;

var _createSubject = require('./createSubject');

var _createSubject2 = _interopRequireDefault(_createSubject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var createBehaviorSubject;

exports.default = createBehaviorSubject = function (opts) {
  var nexted, observable, onlyWhen, presentValue, subjectNext, subjectSubscribe;
  nexted = false;
  presentValue = void 0;
  observable = (0, _createSubject2.default)(opts);
  subjectNext = observable.next;
  if (typeof (opts != null ? opts.onlyWhen : void 0) === 'function') {
    onlyWhen = opts.onlyWhen;
    observable.next = function (x) {
      nexted = true;
      if (onlyWhen(x, presentValue)) {
        return subjectNext.call(this, presentValue = x);
      }
    };
  } else {
    observable.next = function (x) {
      nexted = true;
      return subjectNext.call(this, presentValue = x);
    };
  }
  subjectSubscribe = observable.subscribe;
  observable.subscribe = function (observer) {
    var sub;
    nexted = false;
    sub = subjectSubscribe.call(this, observer);
    if (!sub.closed && !nexted) {
      if (typeof observer.next === "function") {
        observer.next(presentValue);
      }
    }
    return sub;
  };
  observable.getValue = function () {
    return presentValue;
  };
  return observable;
};